/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'follow': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M845.3 145.3v400.1c0 29.9-5.8 59.4-17.4 88.9-11.6 29.3-26.1 55.4-43.2 78.1-17.2 22.8-37.7 44.9-61.4 66.3-23.8 21.6-45.8 39.4-65.8 53.6-20.1 14.2-41.2 27.7-62.9 40.3-21.9 12.7-37.4 21.2-46.6 25.7-9.2 4.5-16.5 8-22.1 10.4-4.2 2.1-8.6 3.2-13.6 3.2-4.8 0-9.4-1.1-13.6-3.2-5.6-2.4-12.9-5.9-22.1-10.4-9.2-4.5-24.7-13.1-46.6-25.7-21.9-12.7-42.9-26.2-62.9-40.3-20.1-14.2-42-32.1-65.8-53.6-23.8-21.6-44.2-43.7-61.4-66.3-17.2-22.8-31.5-48.7-43.2-78.1-11.6-29.3-17.4-58.9-17.4-88.9V145.3c0-9 3.3-16.9 9.9-23.4 6.6-6.6 14.3-9.9 23.4-9.9h600c9 0 16.9 3.3 23.4 9.9 6 6.6 9.3 14.5 9.3 23.4zm-100 400V212H512v592.2c41.3-21.9 78.3-45.7 111-71.3 81.6-64 122.3-126.4 122.3-187.6z" _fill="#555"/>'
  }
})
